<template>
<div>
  <div class="screen-message">
    <div class="message-item text-center">
      <h1>
        <span>連携サイトへ遷移します。</span>
      </h1>
      <p>少々お待ちください。</p>
      <p>待っても画面が変わらない場合は下記のボタンをクリックしてください。</p>
      <div class="back-button">
        <button type="button" class="el-button el-button--success" id="send-mynabi-pdf" 
        style="background-color: #E3165C; border-color: #E3165C; font-size: 120%; margin: 15px 0px 0px;"
         @click="goJobdetail()"><!----><!----><span>遷移する</span></button>
      </div>
    </div>
  </div>
</div>
</template>
<script>
export default {
  methods: {
    goJobdetail: function () {
      location.href = 'https://scp.toppan-edge.co.jp/service/'
    }
  },
  created: function() {
    location.href = 'https://scp.toppan-edge.co.jp/service/'
  }
}
</script>
